export default __webpack_public_path__ + "static/media/Vivenda-do-Camarão-01.c63970b2.jpg";